/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import {
  ArrowLeftOutlined,
  ExperimentOutlined,
  FilterOutlined,
  SearchOutlined,
  UsergroupAddOutlined,
} from '@ant-design/icons';
import {
  Badge,
  Button,
  Card,
  Col,
  Collapse,
  Form,
  Input,
  message,
  Modal,
  Row,
  Space,
  Spin,
  Typography,
} from 'antd';
import { getAreas, getTiposDeEmpleados } from 'api/catalogos';
import { getCategorias, getPlazas } from 'api/catalogos/plazas';
import Table from 'components/Table';
import { getPuestos } from 'api/catalogos/puestos';
import { getVacantes } from 'api/catalogos/Vacantes';
import { getEmpleadosOptimized } from 'api/estructuraOrganizacional/empleados';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { checkToken } from 'api/utils';
import React, { useEffect, useState } from 'react';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import { getSolicitudDeContratacionvistaOptimized } from 'api/reclutamiento/SolicitudesDeContratacion';
import FormSubmitControls from 'components/FormSubmitControls';
import CandidatosPorVacante from './CandidatosPorVacante';
import TituloDivisor from './TituloDivisor';
import PruebasPage from '../Pruebas/Pruebas';

const { Title, Text } = Typography;
const { Panel } = Collapse;

export const listadoDeVacantes = {
  permissionModel: 'solicituddecontratacion',
};

const Vacantes = ({ permission }) => {
  const [form] = Form.useForm();
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [puestos, setPuestos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [tiposEmpleados, setTiposEmpleados] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [tiposDeAsignacion, setTiposDeAsignacion] = useState([]);
  const [tiposNominasEmpleados, setTiposNominasEmpleados] = useState([]);
  const [data, setData] = useState([]);
  const [empleado, setEmpleado] = useState([]);
  const [plazas, setplazas] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isModalPruebas, setIsModalPruebas] = useState(false);
  const [selectedVacante, setSelectedVacante] = useState(null); // para candidatos
  const [selectedVacantePruebas, setSelectedVacantePruebas] = useState(null); // para pruebas

  const normalizeDataAreas = (_areasFetchArray) => {
    const mainMap = new Map();
    _areasFetchArray.forEach((item) => {
      mainMap.set(item.id, { ...item, children: [] });
    });

    const result = [];

    _areasFetchArray.forEach((item) => {
      if (item.directorio_area_padre) {
        const parent = mainMap.get(item.directorio_area_padre);
        if (parent) {
          parent.children.push(mainMap.get(item.id));
        }
      } else {
        result.push(mainMap.get(item.id));
      }
    });

    const sortByClave = (nodes) => {
      nodes.sort((a, b) => a.clave.localeCompare(b.clave));
      nodes.forEach((node) => {
        if (node.children && node.children.length > 0) {
          sortByClave(node.children);
        }
      });
    };

    sortByClave(result);

    return result;
  };
  // Esta función adapta el árbol para que funcione con TreeSelect
  const formatTreeSelectData = (nodes) => nodes.map((node) => ({
    title: `${node.clave} - ${(node.nombre || 'Sin nombre').trim()}`,
    value: node.id,
    children: node.children ? formatTreeSelectData(node.children) : [],
  }));

  function mapVacanteData(
    apiData = { results: [] },
    empleadosData = [],
    puestosData = [],
    plazasData = [],
    areasData = [],
    tiposEmpleadoData = [],
  ) {
    if (!apiData?.results?.map) return [];

    return apiData.results.map((item) => {
      const empleadoEncontrado = empleadosData.find((e) => e.id === item.empleado);
      const puestoSolicitante = puestosData.find((p) => p.id === item.puesto);
      const puestoPlaza = puestosData.find((p) => p.id === item.puesto_plaza);
      const plaza = plazasData.results.find((pl) => pl.id === item.plaza);
      const areaSolicitante = areasData.find((a) => a.id === item.directorio_de_area_adscripcion);
      const areaPlaza = areasData.find((a) => a.id === item.directorio_de_area_adscripcion_plaza);
      const tipoEmpleado = tiposEmpleadoData.find((te) => te.id === item.tipo_empleado);

      return {
        id: item.id,

        // Solicitud
        solicitudFolio: item.folio ? `SOL-${item.folio}` : 'Folio no disponible',
        solicitudFecha: item.fecha_de_solicitud
          ? new Date(item.fecha_de_solicitud).toLocaleDateString('es-MX', { day: 'numeric', month: 'numeric', year: 'numeric' })
          : 'Fecha no disponible',
        numeroOficio: item.no_de_oficio || 'Sin número',

        // Solicitante
        solicitanteId: empleadoEncontrado?.id || 'Desconocido',
        solicitanteNombre: `${empleadoEncontrado?.nombre || ''} ${empleadoEncontrado?.apellido_paterno || ''} ${empleadoEncontrado?.apellido_materno || ''}`.trim() || 'Desconocido',
        solicitanteAreaCodigo: areaSolicitante?.clave || 'N/A',
        solicitanteAreaNombre: areaSolicitante?.nombre || 'Área no encontrada',
        solicitantePuesto: puestoSolicitante?.descripcion || 'Sin puesto',
        solicitantePlaza: plaza?.clave || 'Sin plaza asignada',

        // Vacante
        vacanteAreaCodigo: areaPlaza?.clave || 'N/A',
        vacanteAreaNombre: areaPlaza?.nombre || 'Área no encontrada',
        vacantePlaza: plaza?.clave || 'Sin plaza asignada',
        vacantePuesto: puestoPlaza?.descripcion || 'Sin puesto',
        vacanteCodigo: puestoPlaza?.descripcion || `PLZ-${item.plaza ?? 'Desconocida'}`,
        vacanteEstatus: item.estados_globales === 1 ? 'Activa' : 'Inactiva',
        vacanteMotivo: item.motivo || 'Motivo no especificado',

        // Tipo de Empleado
        empleadoTipo: tipoEmpleado?.descripcion || 'Tipo no definido',

        // Otros
        candidatosTotal: Math.floor(Math.random() * 10), // valor temporal
        pruebasAsignadas: item.pruebas_asignadas || ['Técnica Frontend', 'Psicométrica General'], // ejemplo
      };
    });
  }

  const withId = (arr = []) => arr.map((r) => ({ ...r, id: r.vacante_id }));
  // useEffect(() => {
  //   if (Array.isArray(data) && data.length > 0) {
  //     const ordenadas = [...data].sort((a, b) => a.vacante_id - b.vacante_id);
  //     setData(withId(ordenadas)); // <-- importante
  //   } else {
  //     setData([]);
  //   }
  // }, [data]);
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        // _empleado,
        // _tiposEmpleados,
        // _categorias,
        // _puestos,
        // _areas,
        // _tiposNominasEmpleados,
        // _plazas,
        _data,
      ] = await Promise.all([
        // getEmpleadosOptimized(),
        // getTiposDeEmpleados(),
        // getCategorias(),
        // getPuestos({ estados_globales: ESTATUS_AUTORIZADO }),
        // getAreas(),
        // getTiposDeNominasEmpleados(),
        // getPlazas(),
        getSolicitudDeContratacionvistaOptimized(),
      ]);
      // const formattedURS = normalizeDataAreas(_areas);
      // const formattedTreeData = formatTreeSelectData(formattedURS);
      // const formatData = inflateData(_data, _puestos);
      if (mounted) {
        // setEmpleado(_empleado);
        // setTiposNominasEmpleados(_tiposNominasEmpleados);
        // setplazas(_plazas);
        // setTiposEmpleados(_tiposEmpleados);
        // setCategorias(_categorias);
        // setPuestos(_puestos);
        // setAreas(_areas);
        const soloAutorizadas = Array.isArray(_data)
          ? _data.filter((v) => v.vacante_estado_global_id === 4)
          : [];
        setData(withId(soloAutorizadas).sort((a, b) => a.vacante_id - b.vacante_id));
        setLoading(false);
      }
      setLoading(false);
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      titleText: 'Vacante Solicitada',
      // align: 'center',
      children: [
        // {
        //   title: 'Id Vacante',
        //   dataIndex: 'vacante_id',
        //   key: 'vacante_id',
        //   width: 120,
        // },
        {
          title: 'Folio',
          dataIndex: 'vacante__folio',
          key: 'folio',
          width: 120,
        },
        {
          title: 'Fecha de Solicitud',
          dataIndex: 'vacante_fecha_de_solicitud',
          key: 'fecha_de_solicitud',
          width: 150,
        },
        {
          title: 'Área Vacante',
          dataIndex: 'vacante_directorio_de_area_clave_y_nombre',
          key: 'vacante_area',
          width: 250,
          render: (val) => val ?? '—',
        },
        {
          title: 'Puesto Vacante',
          dataIndex: 'vacante_puesto_clave_y_descripcion',
          key: 'vacante_puesto',
          width: 250,
          render: (val) => val ?? '—',
        },
        {
          title: 'Plaza Vacante',
          dataIndex: 'vacante_plaza_clave_y_descripcion',
          key: 'vacante_plaza',
          width: 250,
          render: (val) => val ?? '—',
        },
        {
          title: 'No. de Oficio',
          dataIndex: 'vacante_no_de_oficio',
          key: 'no_de_oficio',
          width: 200,
        },
        {
          title: 'Motivo',
          dataIndex: 'vacante_motivo_de_reclutamiento_nombre',
          key: 'motivo',
          width: 250,
          render: (val) => val ?? '—',
        },
        {
          title: 'Estatus',
          dataIndex: 'vacante_estado_global_descripcion',
          key: 'estatus',
          width: 150,
          render: (val) => val ?? '—',
        },
      ],
    },
    {
      titleText: 'Datos del Solicitante',
      align: 'center',
      children: [
        {
          title: 'Solicitante',
          dataIndex: 'solicitante',
          key: 'solicitante',
          width: 250,
          render: (val) => val ?? '—',
        },
        {
          title: 'Área Solicitante',
          dataIndex: 'solicitante_directorio_de_area_clave_y_nombre',
          key: 'solicitante_area',
          width: 250,
          render: (val) => val ?? '—',
        },
        {
          title: 'Puesto Solicitante',
          dataIndex: 'solicitante_puesto_clave_y_descripcion',
          key: 'solicitante_puesto',
          width: 200,
          render: (val) => val ?? '—',
        },
        {
          title: 'Plaza Solicitante',
          dataIndex: 'solicitante_plaza_clave_y_descripcion',
          key: 'solicitante_plaza',
          width: 250,
          render: (val) => val ?? '—',
        },
        {
          title: 'Tipo de Empleado',
          dataIndex: 'vacante_tipo_de_empleado_descripcion',
          key: 'vacante_tipo_de_empleado_descripcion',
          width: 200,
          render: (val) => val ?? '—',
        },
      ],
    },
  ];

  useEffect(() => {
    if (selectedVacantePruebas?.vacante_id) { /* ignore */ }
  }, [selectedVacantePruebas]);

  const getBadgeStatus = (estado) => {
    switch (estado) {
      case 'Activa':
        return 'default';
      case 'Autorizada':
      case 'Cita para Entrevista':
        return 'processing';
      case 'Cancelada':
        return 'error';
      case 'En Reclutamiento':
      case 'En Evaluación':
        return 'warning';
      case 'Seleccionado(a)':
      case 'Contratado(a)':
        return 'success';
      default:
        return 'default';
    }
  };

  const vacantes = mapVacanteData(data, empleado, puestos, plazas, areas, tiposEmpleados);
  const vacantesFiltradas = vacantes.filter((v) => v.vacantePlaza?.toLowerCase().includes(searchTerm.toLowerCase()));

  if (selectedVacante) {
    return (
      <div style={{ padding: 10 }}>
        <Button
          type="link"
          icon={<ArrowLeftOutlined />}
          onClick={() => setSelectedVacante(null)}
          style={{ marginBottom: 30 }}
        >
          Volver a Vacantes
        </Button>
        <CandidatosPorVacante vacante={selectedVacante} />
      </div>
    );
  }
  // Función para manejar el clic en una fila de la tabla
  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  // Función para manejar el tipo de selección de filas
  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };
  // Manejar "Gestionar Candidatos"
  const onClickGestionarCandidatos = () => {
    const target = data.find((item) => item.vacante_id === selectedRowKeys[0]);
    if (!target) {
      message.warning('Debes seleccionar una vacante primero.');
      return;
    }
    setSelectedVacante({
      ...target,
      solicitudFecha: target.solicitudFecha || '',
      solicitudFolio: target.solicitudFolio || '',
      pruebasAsignadas: target.pruebasAsignadas || [],
    });
  };

  const onClickPruebas = () => {
    const target = data.find((item) => item.vacante_id === selectedRowKeys[0]);
    if (!target) {
      message.warning('Debes seleccionar una vacante primero.');
      return;
    }
    setSelectedVacantePruebas(target);
    setIsModalPruebas(true);
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {/* Botonera superior */}
        {/* <Row justify="end" gutter={8} style={{ marginBottom: 12 }}>
        <Col>
          <Button
            onClick={onClickGestionarCandidatos}
            disabled={!selectedRowKeys.length}
            icon={<UsergroupAddOutlined />}
            type="primary"
          >
            Gestionar Candidatos
          </Button>
        </Col>
        <Col>
          <Button
            onClick={onClickPruebas}
            disabled={!selectedRowKeys.length}
            icon={<ExperimentOutlined />}
          >
            Pruebas
          </Button>
        </Col>
      </Row> */}
        <Table
          rowKey="vacante_id"
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          permission={permission}
          allowExportPDF={false}
          pagination
          customActions={[
            // {
            //   text: 'Gestionar Candidatos',
            //   icon: <UsergroupAddOutlined />,
            //   onClick: onClickGestionarCandidatos,
            //   disabledBySelection: true, // solo habilita si hay fila seleccionada

            // },
            {
              text: 'Pruebas',
              icon: <UsergroupAddOutlined />,
              onClick: onClickPruebas,
              disabledBySelection: true,
            },
          ]}
        />

        <Modal
          open={isModalPruebas}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          forceRender
          width="80%"
          onCancel={() => setIsModalPruebas(false)}
          title={(
            <FormSubmitControls
              label="Asignar Pruebas"
              onCancel={() => setIsModalPruebas(false)}
              allowSave={false}
            />
  )}
        >

          <PruebasPage vacanteId={selectedVacantePruebas?.vacante_id} />
        </Modal>

      </Spin>
    </Row>

  );
};

export default Vacantes;
